module.exports = __webpack_public_path__ + "static/media/n.22b00b57.png";